import { fromAPI } from "@cur8/rich-entity";
import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";

export function useCreateSessionMutation() {
  const apiClient = useAPIClient();

  return useMutation({
    mutationFn(params: { seed: string; siteId: string }) {
      return apiClient.checkinSession
        .createSession(params)
        .result.then(fromAPI.toCheckinSessionState);
    },
  });
}
